import React from 'react';
import classNames from 'classnames';

import styles from './LinkArea.css';

interface ILinkAreaProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  href: string;
  preventDefault?: boolean;
}

export function LinkArea({ href, children, preventDefault, ...divProps }: ILinkAreaProps) {
  const onLinkClick = React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (preventDefault) {
        e.preventDefault();
      }
    },
    [preventDefault],
  );

  return (
    <div {...divProps} className={classNames(styles['container'], divProps.className)}>
      <a href={href} className={styles['link']} onClick={onLinkClick}>
        <span className={styles['link-area']} />
      </a>
      {children}
    </div>
  );
}
